// src/data/sizeGuideData.js - versión actualizada
export const sizeGuideData = {
  // Camisetas de Adultos
  "Jugador": {
    title: "Guía de Talles - Camiseta Jugador",
    content: [
      { Talle: "S", Pecho_cm: "43-45", Largo_cm: "68-70", Altura_cm: "160-165", Peso_kg: "50-60" },
      { Talle: "M", Pecho_cm: "45-47", Largo_cm: "70-72", Altura_cm: "165-170", Peso_kg: "60-65" },
      { Talle: "L", Pecho_cm: "47-49", Largo_cm: "72-74", Altura_cm: "170-175", Peso_kg: "65-70" },
      { Talle: "XL", Pecho_cm: "49-51", Largo_cm: "74-76", Altura_cm: "175-180", Peso_kg: "70-80" },
      { Talle: "2XL", Pecho_cm: "51-53", Largo_cm: "76-78", Altura_cm: "180-185", Peso_kg: "80-90" },
      { Talle: "3XL", Pecho_cm: "53-56", Largo_cm: "78-80", Altura_cm: "185-190", Peso_kg: "90-100" },
      { Talle: "4XL", Pecho_cm: "60", Largo_cm: "82-84", Altura_cm: "-", Peso_kg: "-" }
    ]
  },
  "Fanatico": {
    title: "Guía de Talles - Camiseta Fanático",
    content: [
      { Talle: "S", Ancho_cm: "48-50", Largo_cm: "69-71", Altura_cm: "160-165", Peso_kg: "60-65" },
      { Talle: "M", Ancho_cm: "50-52", Largo_cm: "71-73", Altura_cm: "165-170", Peso_kg: "66-70" },
      { Talle: "L", Ancho_cm: "52-54", Largo_cm: "73-75", Altura_cm: "170-175", Peso_kg: "71-75" },
      { Talle: "XL", Ancho_cm: "54-56", Largo_cm: "75-77", Altura_cm: "175-180", Peso_kg: "76-80" },
      { Talle: "2XL", Ancho_cm: "56-58", Largo_cm: "77-79", Altura_cm: "180-185", Peso_kg: "81-87" },
      { Talle: "3XL", Ancho_cm: "58-60", Largo_cm: "79-81", Altura_cm: "185-190", Peso_kg: "88-95" },
      { Talle: "4XL", Ancho_cm: "60-62", Largo_cm: "81-83", Altura_cm: "190-195", Peso_kg: "96-103" }
    ]
  },
  "Retro": {
    title: "Guía de Talles - Camiseta Retro",
    content: [
      { Talle: "S", Ancho_cm: "46-48", Largo_cm: "66-68", Altura_cm: "160-165", Peso_kg: "50-60", MangaCorta_cm: "36.5", MangaLarga_cm: "68-70" },
      { Talle: "M", Ancho_cm: "48-50", Largo_cm: "68-70", Altura_cm: "165-170", Peso_kg: "60-65", MangaCorta_cm: "38", MangaLarga_cm: "70-72" },
      { Talle: "L", Ancho_cm: "50-52", Largo_cm: "70-72", Altura_cm: "170-175", Peso_kg: "65-70", MangaCorta_cm: "39.5", MangaLarga_cm: "72-74" },
      { Talle: "XL", Ancho_cm: "52-54", Largo_cm: "72-74", Altura_cm: "175-180", Peso_kg: "70-80", MangaCorta_cm: "41", MangaLarga_cm: "74-76" },
      { Talle: "2XL", Ancho_cm: "54-56", Largo_cm: "74-76", Altura_cm: "180-185", Peso_kg: "80-90", MangaCorta_cm: "42.5", MangaLarga_cm: "76-78" }
    ]
  },
  "MangaLarga_cm": {
    title: "Guía de Talles - Camiseta Manga Larga",
    content: [
      { Talle: "S", Ancho_cm: "50-53", Largo_cm: "67-70", Altura_cm: "165-172", Peso_kg: "50-65" },
      { Talle: "M", Ancho_cm: "53-56", Largo_cm: "70-73", Altura_cm: "172-177", Peso_kg: "56-70" },
      { Talle: "L", Ancho_cm: "56-59", Largo_cm: "73-76", Altura_cm: "177-182", Peso_kg: "62-75" },
      { Talle: "XL", Ancho_cm: "59-62", Largo_cm: "76-79", Altura_cm: "182-190", Peso_kg: "67-88" }
    ]
  },
  "Femenino": {
    title: "Guía de Talles - Camiseta Femenina",
    content: [
      { Talle: "S", Ancho_cm: "42", Largo_cm: "63", Altura_cm: "155-165", Peso_kg: "40-52", Cintura_cm: "39" },
      { Talle: "M", Ancho_cm: "44", Largo_cm: "66", Altura_cm: "165-170", Peso_kg: "52-58", Cintura_cm: "41" },
      { Talle: "L", Ancho_cm: "46", Largo_cm: "69", Altura_cm: "170-175", Peso_kg: "58-65", Cintura_cm: "43" },
      { Talle: "XL", Ancho_cm: "49", Largo_cm: "71", Altura_cm: "175-180", Peso_kg: "65-70", Cintura_cm: "45" },
      { Talle: "2XL", Ancho_cm: "52", Largo_cm: "73", Altura_cm: "180-185", Peso_kg: "70-75", Cintura_cm: "48" }
    ]
  },

  // Conjuntos
  "ConjuntosLargos": {
    title: "Guía de Talles - Conjuntos Largos Adulto",
    content: [
      { Talle: "S", AlturaSuperior_cm: "68-71", SemiPecho_cm: "50-53", Altura_cm: "160-170", Peso_kg: "50-67", AlturaPantalon_cm: "96-98" },
      { Talle: "M", AlturaSuperior_cm: "71-74", SemiPecho_cm: "53-55", Altura_cm: "171-176", Peso_kg: "62-75", AlturaPantalon_cm: "98-101" },
      { Talle: "L", AlturaSuperior_cm: "73-76", SemiPecho_cm: "55-58", Altura_cm: "176-182", Peso_kg: "70-80", AlturaPantalon_cm: "101-104" },
      { Talle: "XL", AlturaSuperior_cm: "75-78", SemiPecho_cm: "57-60", Altura_cm: "182-190", Peso_kg: "81-90", AlturaPantalon_cm: "104-107" },
      { Talle: "2XL", AlturaSuperior_cm: "77-80", SemiPecho_cm: "59-62", Altura_cm: "195-210", Peso_kg: "95-115", AlturaPantalon_cm: "107-110" }
    ]
  },
  "ConjuntosCortos": {
    title: "Guía de Talles - Conjuntos Cortos Adulto",
    content: [
      { Talle: "S", Pecho_cm: "50", Largo_cm: "69", Altura_cm: "155-170", Peso_kg: "55-65" },
      { Talle: "M", Pecho_cm: "52", Largo_cm: "71", Altura_cm: "165-175", Peso_kg: "60-75" },
      { Talle: "L", Pecho_cm: "54", Largo_cm: "73", Altura_cm: "170-185", Peso_kg: "70-85" },
      { Talle: "XL", Pecho_cm: "56", Largo_cm: "75", Altura_cm: "180-195", Peso_kg: "80-100" },
      { Talle: "2XL", Pecho_cm: "58", Largo_cm: "77", Altura_cm: "195-210", Peso_kg: "95-115" }
    ]
  },
  "NiñosCortos": {
    title: "Guía de Talles - Conjuntos Cortos Niños",
    content: [
      { Talle: "16", Largo_cm: "42", SemiPecho_cm: "33", Altura_cm: "95-105", Edad_años: "3-4", AlturaPantalon_cm: "31" },
      { Talle: "18", Largo_cm: "45", SemiPecho_cm: "35", Altura_cm: "105-115", Edad_años: "4-5", AlturaPantalon_cm: "33" },
      { Talle: "20", Largo_cm: "48", SemiPecho_cm: "36.5", Altura_cm: "115-125", Edad_años: "6-7", AlturaPantalon_cm: "35" },
      { Talle: "22", Largo_cm: "50", SemiPecho_cm: "38", Altura_cm: "125-135", Edad_años: "7-8", AlturaPantalon_cm: "37" },
      { Talle: "24", Largo_cm: "55", SemiPecho_cm: "42.5", Altura_cm: "135-145", Edad_años: "8-9", AlturaPantalon_cm: "39" },
      { Talle: "26", Largo_cm: "59", SemiPecho_cm: "44", Altura_cm: "145-155", Edad_años: "10-11", AlturaPantalon_cm: "41" },
      { Talle: "28", Largo_cm: "62", SemiPecho_cm: "45.5", Altura_cm: "155-165", Edad_años: "12-14", AlturaPantalon_cm: "43" }
    ]
  },
  "NiñosLargos": {
    title: "Guía de Talles - Conjuntos Largos Niños",
    content: [
      { Talle: "10", Largo_cm: "55", SemiPecho_cm: "40", Altura_cm: "115-125", AlturaPantalon_cm: "78" },
      { Talle: "12", Largo_cm: "57.5", SemiPecho_cm: "42", Altura_cm: "125-135", AlturaPantalon_cm: "80" },
      { Talle: "14", Largo_cm: "60", SemiPecho_cm: "44", Altura_cm: "135-145", AlturaPantalon_cm: "83" },
      { Talle: "16", Largo_cm: "62.5", SemiPecho_cm: "46", Altura_cm: "145-155", AlturaPantalon_cm: "86" },
      { Talle: "18", Largo_cm: "65", SemiPecho_cm: "48", Altura_cm: "155-165", AlturaPantalon_cm: "89" }
    ]
  }
};
  
export const optionInfoData = {
  "badge": {
    title: "¿Qué es un Parche?",
    content: "Los parches son detalles especiales que se colocan en las mangas o el pecho de la camiseta. Pueden representar competiciones, logros o ediciones conmemorativas. Le dan un toque único y coleccionable a tu prenda.",
    image: "parcheImage"
  },
  "customize": {
    title: "¿Qué es el Dorsal?",
    content: "El dorsal es la estampa con número y/o nombre que se coloca en la parte trasera de la camiseta. Podés elegir el de tu jugador favorito o crear el tuyo, con el número y apodo que más te representen.",
    image: "dorsalImage"
  }
};